import { render } from "./ImageTextSection.vue?vue&type=template&id=0a0cc313&scoped=true"
import script from "./ImageTextSection.vue?vue&type=script&lang=js"
export * from "./ImageTextSection.vue?vue&type=script&lang=js"

import "./ImageTextSection.vue?vue&type=style&index=0&id=0a0cc313&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0cc313"]])

export default __exports__